import { NgModule } from '@angular/core';
import {
  ABTestApiService,
  AB_TEST_ANALYTICS_SERVICE,
  AB_TEST_API_SERVICE,
  AB_TEST_AUTH_SERVICE,
  AB_TEST_BASE_URL,
  AB_TEST_CONFIG,
  AB_TEST_COOKIE_CONSENT_SERVICE,
  AB_TEST_HTTP_SERVICE,
  AB_TEST_PERMISSION_SERVICE,
  AB_TEST_USER_JOURNEY_TRACKER,
  UserJourneyTrackerService,
} from '@campus/ab-test';
import { MAINTENANCE_CHECK_BASE_URL } from '@campus/browser';
import { COOKIES_SERVICE_TOKEN, CookiesService } from '@campus/cookies';
import {
  ALERT_SERVICE_TOKEN,
  ANALYTICS_SERVICE_TOKEN,
  AUTH_SERVICE_TOKEN,
  AlertService,
  AnalyticsService,
  AuthService,
  BUNDLE_SERVICE_TOKEN,
  BearerHttpService,
  BundleService,
  CLASS_GROUP_SERVICE_TOKEN,
  CONCEPT_SERVICE_TOKEN,
  CONCEPT_YEAR_SERVICE_TOKEN,
  CREDENTIAL_SERVICE_TOKEN,
  CURRICULUM_SERVICE_TOKEN,
  CURRICULUM_TREE_CONCEPT_SERVICE_TOKEN,
  CURRICULUM_TREE_SERVICE_TOKEN,
  CURRICULUM_TREE_YEAR_SERVICE_TOKEN,
  ClassGroupService,
  ConceptService,
  ConceptYearService,
  CredentialService,
  CurrentExerciseActions,
  CurriculumService,
  CurriculumTreeConceptService,
  CurriculumTreeService,
  CurriculumTreeYearService,
  DATA_SERVICE_TOKEN,
  DIABOLO_PHASE_SERVICE_TOKEN,
  DIDACTIC_FUNCTION_SERVICE_TOKEN,
  DalState,
  DataService,
  DiaboloPhaseService,
  DidacticFunctionService,
  EDU_CONTENT_BOOK_SERVICE_TOKEN,
  EDU_CONTENT_PRODUCT_TYPE_SERVICE_TOKEN,
  EDU_CONTENT_SERVICE_TOKEN,
  EDU_CONTENT_TOC_LEARNING_DOMAIN_SERVICE_TOKEN,
  EDU_CONTENT_TOC_SERVICE_TOKEN,
  EDU_NET_SERVICE_TOKEN,
  EVALUATION_SUBJECT_GOAL_SERVICE_TOKEN,
  EVALUATION_SUBJECT_SERVICE_TOKEN,
  EduContentBookService,
  EduContentProductTypeService,
  EduContentService,
  EduContentTocLearningDomainService,
  EduContentTocService,
  EduNetService,
  EvaluationSubjectGoalService,
  EvaluationSubjectService,
  FAVORITE_SERVICE_TOKEN,
  FavoriteService,
  GOAL_SERVICE_TOKEN,
  GOAL_YEAR_SERVICE_TOKEN,
  GROUP_PERSON_SERVICE_TOKEN,
  GROUP_SERVICE_TOKEN,
  GoalService,
  GoalYearService,
  GroupPersonService,
  GroupService,
  HISTORY_SERVICE_TOKEN,
  HistoryService,
  LEARNINGAREA_SERVICE_TOKEN,
  LEARNING_DOMAIN_SERVICE_TOKEN,
  LEARNING_PLAN_GOAL_PROGRESS_SERVICE_TOKEN,
  LEARNING_PLAN_GOAL_SERVICE_TOKEN,
  LEARNING_PLAN_SERVICE_TOKEN,
  LEARNING_RECORD_SERVICE_TOKEN,
  LEVEL_SERVICE_TOKEN,
  LOOP_SERVICE_TOKEN,
  LearningAreaService,
  LearningDomainService,
  LearningPlanGoalService,
  LearningPlanService,
  LearningRecordService,
  LevelService,
  LoopService,
  METHOD_LEVEL_SERVICE_TOKEN,
  METHOD_PRODUCT_GROUP_PRODUCT_SERVICE_TOKEN,
  METHOD_PRODUCT_GROUP_SERVICE_TOKEN,
  METHOD_SERVICE_TOKEN,
  MethodLevelService,
  MethodProductGroupProductService,
  MethodProductGroupService,
  MethodService,
  PERSON_PREFERENCE_SERVICE_TOKEN,
  PERSON_PRODUCT_SERVICE_TOKEN,
  PERSON_SERVICE_TOKEN,
  PURCHASE_PRODUCT_SERVICE_TOKEN,
  PURCHASE_SERVICE_TOKEN,
  PersonPreferenceService,
  PersonProductService,
  PersonService,
  PurchaseProductService,
  PurchaseService,
  ResultActions,
  ResultInterface,
  SCHOOL_BILLING_ADDRESS_SERVICE_TOKEN,
  SCHOOL_SERVICE_TOKEN,
  SCHOOL_TYPE_SERVICE_TOKEN,
  STUDENT_CONTENT_STATUS_SERVICE_TOKEN,
  SchoolBillingAddressService,
  SchoolService,
  SchoolTypeService,
  StudentContentStatusService,
  TASK_CLASS_GROUP_SERVICE_TOKEN,
  TASK_EDU_CONTENT_SERVICE_TOKEN,
  TASK_EVALUATION_SUBJECT_SCORE_SERVICE_TOKEN,
  TASK_EVALUATION_SUBJECT_SERVICE_TOKEN,
  TASK_GOAL_YEAR_LEVEL_SERVICE_TOKEN,
  TASK_GROUP_SERVICE_TOKEN,
  TASK_INSTANCE_SERVICE_TOKEN,
  TASK_LEVEL_SETTING_SERVICE_TOKEN,
  TASK_SERVICE_TOKEN,
  TASK_STUDENT_SERVICE_TOKEN,
  TaskClassGroupService,
  TaskEduContentService,
  TaskEvaluationSubjectScoreService,
  TaskEvaluationSubjectService,
  TaskGoalYearLevelService,
  TaskGroupService,
  TaskInstanceService,
  TaskLevelSettingService,
  TaskService,
  TaskStudentService,
  UNLOCKED_BOEKE_GROUP_SERVICE_TOKEN,
  UNLOCKED_BOEKE_STUDENT_SERVICE_TOKEN,
  UNLOCKED_CONTENT_SERVICE_TOKEN,
  UNLOCKED_CURRICULUM_TREE_SERVICE_TOKEN,
  UNLOCKED_FREE_PRACTICE_SERVICE_TOKEN,
  USER_GAME_PROFILE_SERVICE,
  USER_LESSON_SERVICE_TOKEN,
  UnlockedBoekeGroupService,
  UnlockedBoekeStudentService,
  UnlockedContentService,
  UnlockedCurriculumTreeService,
  UnlockedFreePracticeService,
  UserGameProfileService,
  UserLessonService,
  YEAR_SERVICE_TOKEN,
  YearService,
} from '@campus/dal';
import { EXERCISE_TOKEN, ExerciseService } from '@campus/exercise';
import { GeogebraExerciseService } from '@campus/geogebra';
import { LearnosityOpenerService, RESULT_UPDATER_TOKEN } from '@campus/learnosity';
import { FAVORITE_BOOKS_SERVICE_TOKEN, PolpoFavoriteBooksService } from '@campus/pages/shared';
import { ScormExerciseService } from '@campus/scorm';
import {
  APP_NAVIGATION_TREE_TOKEN,
  NAVIGATION_ITEM_SERVICE_TOKEN,
  NavigationItemService,
  PermissionService,
} from '@campus/shared';
import { ObjectFunctions } from '@campus/utils';
import { Store } from '@ngrx/store';
import { environment } from '../environments/environment';
import { polpoConfig } from './app.config';
import {
  SEARCH_TERM_FILTER_FACTORY_TOKEN,
  SearchTermFilterFactory,
} from './factories/search-term-filter/search-term-filter.factory';
import { FAVICON_SERVICE_TOKEN, FavIconService } from './services/favicons';
import { SpeechExerciseService } from '@campus/speech-exercise';

@NgModule({
  providers: [
    //app level services
    { provide: NAVIGATION_ITEM_SERVICE_TOKEN, useClass: NavigationItemService },
    { provide: APP_NAVIGATION_TREE_TOKEN, useValue: polpoConfig.appNavtree },
    {
      provide: FAVICON_SERVICE_TOKEN,
      useClass: FavIconService,
    },
    {
      provide: SEARCH_TERM_FILTER_FACTORY_TOKEN,
      useClass: SearchTermFilterFactory,
    },

    {
      provide: NAVIGATION_ITEM_SERVICE_TOKEN,
      useClass: NavigationItemService,
    },
    // dal services
    { provide: EDU_CONTENT_SERVICE_TOKEN, useClass: EduContentService },
    {
      provide: UNLOCKED_BOEKE_STUDENT_SERVICE_TOKEN,
      useClass: UnlockedBoekeStudentService,
    },
    {
      provide: UNLOCKED_CONTENT_SERVICE_TOKEN,
      useClass: UnlockedContentService,
    },
    {
      provide: UNLOCKED_BOEKE_GROUP_SERVICE_TOKEN,
      useClass: UnlockedBoekeGroupService,
    },
    { provide: BUNDLE_SERVICE_TOKEN, useClass: BundleService },
    { provide: LEARNINGAREA_SERVICE_TOKEN, useClass: LearningAreaService },
    { provide: METHOD_SERVICE_TOKEN, useClass: MethodService },
    {
      provide: STUDENT_CONTENT_STATUS_SERVICE_TOKEN,
      useClass: StudentContentStatusService,
    },
    {
      provide: ALERT_SERVICE_TOKEN,
      useClass: AlertService,
    },
    { provide: PERSON_SERVICE_TOKEN, useClass: PersonService },
    { provide: AUTH_SERVICE_TOKEN, useClass: AuthService },
    { provide: TASK_SERVICE_TOKEN, useClass: TaskService },
    { provide: TASK_INSTANCE_SERVICE_TOKEN, useClass: TaskInstanceService },
    {
      provide: TASK_EDU_CONTENT_SERVICE_TOKEN,
      useClass: TaskEduContentService,
    },
    { provide: CREDENTIAL_SERVICE_TOKEN, useClass: CredentialService },
    { provide: EDU_NET_SERVICE_TOKEN, useClass: EduNetService },
    {
      provide: EDU_CONTENT_PRODUCT_TYPE_SERVICE_TOKEN,
      useClass: EduContentProductTypeService,
    },
    { provide: SCHOOL_TYPE_SERVICE_TOKEN, useClass: SchoolTypeService },
    { provide: SCHOOL_SERVICE_TOKEN, useClass: SchoolService },
    { provide: YEAR_SERVICE_TOKEN, useClass: YearService },
    { provide: LEARNING_PLAN_SERVICE_TOKEN, useClass: LearningPlanService },
    { provide: FAVORITE_SERVICE_TOKEN, useClass: FavoriteService },
    { provide: EDU_CONTENT_TOC_SERVICE_TOKEN, useClass: EduContentTocService },
    {
      provide: EDU_CONTENT_TOC_LEARNING_DOMAIN_SERVICE_TOKEN,
      useClass: EduContentTocLearningDomainService,
    },
    { provide: LEARNING_DOMAIN_SERVICE_TOKEN, useClass: LearningDomainService },
    { provide: HISTORY_SERVICE_TOKEN, useClass: HistoryService },
    { provide: DIABOLO_PHASE_SERVICE_TOKEN, useClass: DiaboloPhaseService },
    { provide: GROUP_SERVICE_TOKEN, useClass: GroupService },
    { provide: GROUP_PERSON_SERVICE_TOKEN, useClass: GroupPersonService },
    { provide: CLASS_GROUP_SERVICE_TOKEN, useClass: ClassGroupService },
    {
      provide: EDU_CONTENT_BOOK_SERVICE_TOKEN,
      useClass: EduContentBookService,
    },
    {
      provide: DATA_SERVICE_TOKEN,
      useClass: DataService,
    },
    {
      provide: EDU_CONTENT_BOOK_SERVICE_TOKEN,
      useClass: EduContentBookService,
    },
    {
      provide: DIDACTIC_FUNCTION_SERVICE_TOKEN,
      useClass: DidacticFunctionService,
    },
    {
      provide: CLASS_GROUP_SERVICE_TOKEN,
      useClass: ClassGroupService,
    },
    {
      provide: DIABOLO_PHASE_SERVICE_TOKEN,
      useClass: DiaboloPhaseService,
    },
    {
      provide: LEARNING_PLAN_GOAL_SERVICE_TOKEN,
      useClass: LearningPlanGoalService,
    },
    {
      provide: LEARNING_PLAN_GOAL_PROGRESS_SERVICE_TOKEN,
      useClass: LearningPlanGoalService,
    },
    {
      provide: USER_LESSON_SERVICE_TOKEN,
      useClass: UserLessonService,
    },
    { provide: PERSON_PREFERENCE_SERVICE_TOKEN, useClass: PersonPreferenceService },
    { provide: PERSON_PRODUCT_SERVICE_TOKEN, useClass: PersonProductService },
    { provide: LEVEL_SERVICE_TOKEN, useClass: LevelService },
    { provide: TASK_CLASS_GROUP_SERVICE_TOKEN, useClass: TaskClassGroupService },
    { provide: TASK_GROUP_SERVICE_TOKEN, useClass: TaskGroupService },
    { provide: TASK_STUDENT_SERVICE_TOKEN, useClass: TaskStudentService },
    { provide: CONCEPT_SERVICE_TOKEN, useClass: ConceptService },
    { provide: USER_GAME_PROFILE_SERVICE, useClass: UserGameProfileService },

    // TASK PAGES
    { provide: GOAL_SERVICE_TOKEN, useClass: GoalService },
    { provide: GOAL_YEAR_SERVICE_TOKEN, useClass: GoalYearService },
    { provide: TASK_EVALUATION_SUBJECT_SERVICE_TOKEN, useClass: TaskEvaluationSubjectService },
    { provide: TASK_EVALUATION_SUBJECT_SCORE_SERVICE_TOKEN, useClass: TaskEvaluationSubjectScoreService },
    { provide: EVALUATION_SUBJECT_GOAL_SERVICE_TOKEN, useClass: EvaluationSubjectGoalService },
    { provide: GOAL_SERVICE_TOKEN, useClass: GoalService },
    { provide: GOAL_YEAR_SERVICE_TOKEN, useClass: GoalYearService },
    { provide: TASK_GOAL_YEAR_LEVEL_SERVICE_TOKEN, useClass: TaskGoalYearLevelService },
    { provide: TASK_LEVEL_SETTING_SERVICE_TOKEN, useClass: TaskLevelSettingService },
    { provide: EVALUATION_SUBJECT_SERVICE_TOKEN, useClass: EvaluationSubjectService },

    { provide: METHOD_LEVEL_SERVICE_TOKEN, useClass: MethodLevelService },
    { provide: UNLOCKED_FREE_PRACTICE_SERVICE_TOKEN, useClass: UnlockedFreePracticeService },
    {
      provide: METHOD_PRODUCT_GROUP_SERVICE_TOKEN,
      useClass: MethodProductGroupService,
    },

    {
      provide: PURCHASE_SERVICE_TOKEN,
      useClass: PurchaseService,
    },
    {
      provide: PURCHASE_PRODUCT_SERVICE_TOKEN,
      useClass: PurchaseProductService,
    },
    {
      provide: METHOD_PRODUCT_GROUP_PRODUCT_SERVICE_TOKEN,
      useClass: MethodProductGroupProductService,
    },
    {
      provide: MAINTENANCE_CHECK_BASE_URL,
      useValue: environment.website.url + '/',
    },
    ExerciseService,
    { provide: EXERCISE_TOKEN, multi: true, useClass: LearnosityOpenerService },
    { provide: EXERCISE_TOKEN, multi: true, useClass: ScormExerciseService },
    { provide: EXERCISE_TOKEN, multi: true, useClass: GeogebraExerciseService },
    { provide: EXERCISE_TOKEN, multi: true, useClass: SpeechExerciseService },
    {
      provide: RESULT_UPDATER_TOKEN,
      useFactory: (store: Store<DalState>) => (result: ResultInterface, finalUpdate?: boolean) => {
        const mappedResult = ObjectFunctions.castAs(Date)(['created', 'lastUpdated'])(result);

        store.dispatch(new ResultActions.UpsertResult({ result: mappedResult }));
        store.dispatch(new CurrentExerciseActions.SetCurrentResult({ result: mappedResult, finalUpdate }));

        if (finalUpdate) {
          store.dispatch(
            new CurrentExerciseActions.SetReadyForNextRecommendation({ readyForNextRecommendation: true })
          );
        }
      },
      deps: [Store],
    },
    {
      provide: FAVORITE_BOOKS_SERVICE_TOKEN,
      useClass: PolpoFavoriteBooksService,
    },
    {
      provide: LEARNING_RECORD_SERVICE_TOKEN,
      useClass: LearningRecordService,
    },
    { provide: CURRICULUM_SERVICE_TOKEN, useClass: CurriculumService },
    { provide: CURRICULUM_TREE_SERVICE_TOKEN, useClass: CurriculumTreeService },
    {
      provide: CURRICULUM_TREE_YEAR_SERVICE_TOKEN,
      useClass: CurriculumTreeYearService,
    },
    {
      provide: CURRICULUM_TREE_CONCEPT_SERVICE_TOKEN,
      useClass: CurriculumTreeConceptService,
    },
    {
      provide: CURRICULUM_TREE_YEAR_SERVICE_TOKEN,
      useClass: CurriculumTreeYearService,
    },
    { provide: CONCEPT_YEAR_SERVICE_TOKEN, useClass: ConceptYearService },
    {
      provide: UNLOCKED_CURRICULUM_TREE_SERVICE_TOKEN,
      useClass: UnlockedCurriculumTreeService,
    },
    { provide: LOOP_SERVICE_TOKEN, useClass: LoopService },
    {
      provide: SCHOOL_BILLING_ADDRESS_SERVICE_TOKEN,
      useClass: SchoolBillingAddressService,
    },

    { provide: ANALYTICS_SERVICE_TOKEN, useClass: AnalyticsService },
    { provide: COOKIES_SERVICE_TOKEN, useClass: CookiesService },

    // AB-TESTING
    { provide: AB_TEST_USER_JOURNEY_TRACKER, useClass: UserJourneyTrackerService },
    { provide: AB_TEST_HTTP_SERVICE, useClass: BearerHttpService },
    { provide: AB_TEST_BASE_URL, useValue: environment.api.APIV2Base },
    { provide: AB_TEST_API_SERVICE, useClass: ABTestApiService },
    { provide: AB_TEST_AUTH_SERVICE, useExisting: AuthService },
    { provide: AB_TEST_ANALYTICS_SERVICE, useExisting: ANALYTICS_SERVICE_TOKEN },
    { provide: AB_TEST_COOKIE_CONSENT_SERVICE, useExisting: COOKIES_SERVICE_TOKEN },
    { provide: AB_TEST_PERMISSION_SERVICE, useClass: PermissionService },
    { provide: AB_TEST_CONFIG, useValue: environment.abTestConfig },
  ],
})
export class AppTokenModule {}
